import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {
  ContractService,
  Contract,
  GetContractsRequest,
} from '@app/core/services/contract/contract.service'
import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '@app/core/services/generic-list.service'
import {SearchFilter} from '@app/core/services/search/search-filter.interface'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

export interface ContractRequest extends LoadRequest {
  query: string
  sortField: string
  sortAsc: boolean
}

@Injectable()
export class ContractListService extends GenericListService<Contract> {
  filter: SearchFilter

  constructor(
    private contractSvc: ContractService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<Contract>> {
    // build the service request
    const svcRequest: GetContractsRequest = {
      domain: request.domain,
      offset: request.offset,
      results: request.count,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.contractSvc.getContracts(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<Contract> = {
          total: res.count,
          items: res.results,
        }
        return result
      }),
    )
  }
}
